module.exports = __webpack_public_path__ + "img/rarity_birthday.f03308a2.png";